import 'daterangepicker/daterangepicker.js'
import moment from 'moment/moment.js'

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["single"]

  connect() {

    if (this.singleTargets.length > 0) {
      this.singleTargets.forEach((el) => {
        this.singlemount(el)
        document.addEventListener('turbolinks:before-cache', () => {
          this.singleunmount(el)
        }, {once: true})
      })
    }

  }

  singleunmount(theSingle) {
    $(theSingle).data('daterangepicker').remove()
  }

  singlemount(theSingle) {

    const locale = JSON.parse(theSingle.getAttribute('data-locale'))
    const time = JSON.parse(theSingle.getAttribute('data-time'))

    theSingle.placeholder = locale.format

    let options = {
      locale: locale,
      singleDatePicker: true,
      autoApply: true,
      showDropdowns: true,
      autoUpdateInput: false,
      startDate: moment().startOf('hour'),
      endDate: moment().startOf('hour').add(32, 'hour')
    }

    if (time) {
      options['timePicker'] = true
      options['timePicker24Hour'] = true
    }

    let date_array = theSingle.value.split(' ')
    let date_str = (time && date_array[0].length > 1) ? `${date_array[0]} ${date_array[1]}` : `${date_array[0]}`

    $(theSingle).daterangepicker(options).on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format(locale.format))
    })

  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d)
  }

}
